<template>
  <b-modal
    :id="id || 'transition-business-modal'"
    @hidden="reason = ''"
  >

    <h4 class="text-center">
      Are you sure you want to {{ action == 'APPROVE'? 'Approve': 'Reject' }} {{ entityName }}
    </h4>

    <b-form-textarea
      v-if="action == 'REJECT'"
      v-model="reason"
      placeholder="Rejection Reason"
    />

    <template #modal-footer="{close}">
      <b-row style="width:100%">
        <b-col md="6">
          <b-button
            block
            @click="close"
          >
            Cancel
          </b-button>
        </b-col>
        <b-col md="6">
          <b-button
            :disabled="submitting || (action == 'REJECT' && !reason)"
            block
            :variant="action == 'APPROVE' ? 'success' : 'danger'"
            @click="applyTransition"
          >
            <BSpinner
              v-if="submitting"
              small
            />
            <span v-else>{{ action == 'APPROVE'? 'Approve': 'Reject' }}</span>
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import { computed, ref } from '@vue/composition-api'
import {
  BModal, BButton, BSpinner, BRow, BCol, BFormTextarea,
} from 'bootstrap-vue'

export default {
  components: {
    BModal, BButton, BSpinner, BRow, BCol, BFormTextarea,
  },
  props: {
    entity: {
      type: Object,
      required: true,
    },
    entityType: {
      type: String,
      required: true,
      validator: val => ['Branch', 'Business'].includes(val),
    },
    action: {
      type: String,
      required: true,
      validator: val => ['APPROVE', 'REJECT'].includes(val),
    },
    id: {
      type: String,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const submitting = ref(false)
    const reason = ref('')

    const applyTransition = async () => {
      submitting.value = true
      try {
        if (props.entityType === 'Business') {
          await ctx.root.$store.dispatch('business/transitionBusiness', {
            businessId: props.entity.id,
            body: {
              action: props.action,
              rejectionReason: props.action === 'REJECT' ? reason.value : undefined,
            },
          })
        } else {
          console.log(props.entity)
          await ctx.root.$store.dispatch('business/transitionBusinessBranch', {
            businessId: props.entity.businessId,
            branchId: props.entity.id,
            body: {
              action: props.action,
              rejectionReason: props.action === 'REJECT' ? reason.value : undefined,
            },
          })
        }
        ctx.emit('transition-applied')
        ctx.root.$bvModal.hide('transition-business-modal')
      } finally {
        submitting.value = false
      }
    }
    const entityName = computed(() => props.entity?.name?.en || '')

    return {
      submitting,
      entityName,
      applyTransition,
      reason,
    }
  },
}
</script>

<style>

</style>
